export { FloatingActionButton, FloatingActionButtonProps } from './components/FloatingActionButton';
